module.exports = __webpack_public_path__ + "img/headBg.acbf5ab8.png";